import User from "./User";
import Axios from "axios";
import moment from "moment";
import EventGroups from "./EventGroups";
import Schedules from "./Schedules";

class ReservationsClass {

  constructor() {
    this.reservations = /** @type {Reservation[]} */ ([]);
    this.reservationsByUnit = /** @type {Reservation[]} */ ([]);
    this.locked = false;
  }

  /**
   * @param {number} id
   */
  get(id) {
    for (let reservation of this.reservations) {
      if (reservation.id == id) {
        return reservation;
      }
    }
    return null;
  }


  /**
   * @param {number} id
   * @return {Reservation[]}
   */
  getActiveBookingsForService(id) {
    return this.reservations.filter(r => r.isActiveForService(id));
  }

  getActiveBookingsForServiceForCurrentLease(id) {
    return this.reservationsByUnit.filter(r => r.isActiveForService(id));
  }

  async init() {
    if (!User.token || this.locked) {
      return;
    }
    try{
      this.locked = true;
      let reservations = await Axios.get(CONFIG.urlServer + "/api/reservations", {
        params: {
          user: User.id,
          perPage: -1
        },
        headers: {
          "Authorization": "Bearer " + User.token
        }
      });
      this.reservations = [];
      for (let definition of reservations.data.data) {
        this.reservations.push(new Reservation(definition));
      }

      if (!User.lease) {
        return;
      }
      let reservationsByUnit = await Axios.get(CONFIG.urlServer + "/api/reservations", {
        params: {
          lease: User.lease,
          perPage: -1
        },
        headers: {
          "Authorization": "Bearer " + User.token
        }
      });
      this.reservationsByUnit = [];
      for (let definition of reservationsByUnit.data.data) {
        this.reservationsByUnit.push(new Reservation(definition));
      }
      this.locked = false;
    }
    catch(e) {
      console.log(e);
      this.locked = false;
    }
  }
}

/**
 * @typedef ReservationDefinition
 * @property {number} id
 * @property {number} entity
 * @property {number} event
 * @property {number} user
 * @property {string} start
 * @property {number} total
 * @property {string} end
 * @property {string} canceledAt
 * @property {string} canceledBy
 * @property {string} currency
 */

export class Reservation {
  /**
   * @param {RequestDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.event = definition.event;
    this.schedule = definition.entity;
    this.user = definition.user;
    this.total = definition.total;
    this.currency = definition.currency;
    this.payments = definition.payments;
    this.start = moment(definition.start);
    this.end = moment(definition.end);
    this.cancelled = !!definition.canceledAt || !!definition.canceledBy;
  }

  getEntity() {
    return this.getEvent() || this.getSchedule();
  }

  getEvent() {
    if (this.event) {
      return EventGroups.getEvent(this.event);
    }
  }

  getSchedule() {
    if (this.schedule) {
      return Schedules.get(this.schedule);
    }
  }

  isActiveForService(id) {
    let entity = this.getEntity();
    return entity && entity.service === id && this.start.isAfter(moment()) && !this.cancelled
  }

  /**
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  async cancelReservation() {
    let result = await Axios.put(CONFIG.urlServer + "/api/reservations/"+ this.id +"/cancel", null, {
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });

    return result;
  }

}

let Reservations = new ReservationsClass();
export default Reservations;
